const docsUrl = 'https://github.com/Vitor-Xavier/CalculationEngine/wiki';

/**
 * Palavras chave definidas na linguagem do cálculo.
 */
export const keywords = [
  {
    nome: 'nulo',
    texto: 'nulo',
    descricao: 'nulo',
    definicao: `${docsUrl}#instrução-nulo`,
  },
  {
    nome: 'var',
    texto: 'var',
    descricao: 'variável',
    definicao: `${docsUrl}#instrução-var`,
  },
  {
    nome: 'se',
    texto: 'se',
    descricao: 'se',
    definicao: `${docsUrl}#instrução-se`,
  },
  {
    nome: 'senao',
    texto: 'senao',
    descricao: 'senao',
    definicao: `${docsUrl}#instrução-se-senão`,
  },
  {
    nome: 'enquanto',
    texto: 'enquanto',
    descricao: 'enquanto',
    definicao: `${docsUrl}#instrução-enquanto`,
  },
  {
    nome: 'parar',
    texto: 'parar',
    descricao: 'parar',
    definicao: `${docsUrl}#instrução-parar`,
  },
  {
    nome: 'parametro',
    texto: 'parametro',
    descricao: 'parametro',
    definicao: `${docsUrl}#instrução-parâmetro`,
  },
  {
    nome: 'caso',
    texto: 'caso',
    descricao: 'caso',
    definicao: `${docsUrl}#instrução-caso`,
  },
  {
    nome: 'padrao',
    texto: 'padrao',
    descricao: 'padrao',
    definicao: `${docsUrl}#instrução-padrão`,
  },
  {
    nome: 'retorno',
    texto: 'retorno',
    descricao: 'retorno',
    definicao: `${docsUrl}#instrução-retorno`,
  },
];

/**
 * Documentação de funções de suporte disponíveis na linguagem do cálculo.
 */
export const functions = [
  {
    nome: '_DATA',
    texto: '_DATA(${1:dia}, ${2:mes}, ${3:ano})',
    assinatura: '(dia, mes, ano, hora, minuto)',
    descricao: 'Cria uma nova data com base nos parâmetros informados.',
    definicao: `${docsUrl}#_data`,
    exemplo: 'var data = _DATA(31, 03, 2020, 10, 40);',
    parametros: [
      { nome: 'dia', descricao: 'Dia, referente ao dia do mês.' },
      { nome: 'mes', descricao: 'Mês, referente ao mês do ano (entre 1 e 12).' },
      { nome: 'ano', descricao: 'Ano (entre 1 e 9999).' },
      { nome: 'hora', descricao: '(Opcional) Hora (entre 0 e 23).' },
      { nome: 'minuto', descricao: '(Opcional) Minuto (entre 1 e 59).' },
    ],
  },
  {
    nome: '_HOJE',
    texto: '_HOJE()',
    assinatura: '()',
    descricao: 'Retorna a data atual.',
    definicao: `${docsUrl}#_hoje`,
    exemplo: 'var data = _HOJE();',
    parametros: [],
  },
  {
    nome: '_AGORA',
    texto: '_AGORA()',
    assinatura: '()',
    descricao: 'Retorna a data e hora atual.',
    definicao: `${docsUrl}#_agora`,
    exemplo: 'var dataHora = _AGORA();',
    parametros: [],
  },
  {
    nome: '_DATADIF',
    texto: '_DATADIF(${1:dataInicial}, ${2:dataFinal}, ${3:unidade})',
    assinatura: '(dataInicial, dataFinal, unidade)',
    descricao: 'Retorna a diferença entre as datas na unidade informada.',
    definicao: `${docsUrl}#_datadif`,
    exemplo: 'var dif = _DATADIF(dataInicial, dataFinal, DIA);',
    parametros: [
      { nome: 'dataInicial', descricao: 'Data inicial para comparação' },
      { nome: 'dataFinal', descricao: 'Data final para comparação' },
      { nome: 'unidade', descricao: 'Unidade de retorno. (DIA, MES ou ANO)' },
    ],
  },
  {
    nome: '_ANO',
    texto: '_ANO(${1:data})',
    assinatura: '(data)',
    descricao: 'Retorna o ano da data especificada.',
    definicao: `${docsUrl}#_ano`,
    exemplo: 'var ano = _ANO(data);',
    parametros: [{ nome: 'data', descricao: 'Data para se realizar a operação' }],
  },
  {
    nome: '_MES',
    texto: '_MES(${1:data})',
    assinatura: '(data)',
    descricao: 'Retorna o mês da data especificada.',
    definicao: `${docsUrl}#_mes`,
    exemplo: 'var mes = _MES(data);',
    parametros: [{ nome: 'data', descricao: 'Data para se realizar a operação' }],
  },
  {
    nome: '_DIA',
    texto: '_DIA(${1:data})',
    assinatura: '(data)',
    descricao: 'Retorna o dia da data especificada.',
    definicao: `${docsUrl}#_dia`,
    exemplo: 'var dia = _DIA(data);',
    parametros: [{ nome: 'data', descricao: 'Data para se realizar a operação' }],
  },
  {
    nome: '_HORA',
    texto: '_HORA(${1:dataHora})',
    assinatura: '(dataHora)',
    descricao: 'Retorna a hora da data especificada.',
    definicao: `${docsUrl}#_hora`,
    exemplo: 'var hora = _HORA(dataHora);',
    parametros: [{ nome: 'dataHora', descricao: 'Data para se realizar a operação' }],
  },
  {
    nome: '_MINUTO',
    texto: '_MINUTO(${1:dataHora})',
    assinatura: '(dataHora)',
    descricao: 'Retorna o minuto da data especificada.',
    definicao: `${docsUrl}#_minuto`,
    exemplo: 'var minuto = _MINUTO(dataHora);',
    parametros: [{ nome: 'dataHora', descricao: 'Data para se realizar a operação' }],
  },
  {
    nome: '_ANO_ADICIONAR',
    texto: '_ANO_ADICIONAR(${1:data}, ${2:anos})',
    assinatura: '(data, anos)',
    descricao: 'Retorna a data acrescida da quantidade de anos especificada.',
    definicao: `${docsUrl}#_ano_adicionar`,
    exemplo: 'var novaData = _ANO_ADICIONAR(data, 2);',
    parametros: [
      { nome: 'data', descricao: 'Data para se realizar a operação' },
      { nome: 'anos', descricao: 'Quantidade de anos a se adicionar' },
    ],
  },
  {
    nome: '_MES_ADICIONAR',
    texto: '_MES_ADICIONAR(${1:data}, ${2:meses})',
    assinatura: '(data, meses)',
    descricao: 'Retorna a data acrescida da quantidade de meses especificada.',
    definicao: `${docsUrl}#_mes_adicionar`,
    exemplo: 'var novaData = _MES_ADICIONAR(data, 10);',
    parametros: [
      { nome: 'data', descricao: 'Data para se realizar a operação' },
      { nome: 'meses', descricao: 'Quantidade de meses a se adicionar' },
    ],
  },
  {
    nome: '_DIA_ADICIONAR',
    texto: '_DIA_ADICIONAR(${1:data}, ${2:dias})',
    assinatura: '(data, dias)',
    descricao: 'Retorna a data acrescida da quantidade de dias especificada.',
    definicao: `${docsUrl}#_dia_adicionar`,
    exemplo: 'var novaData = _DIA_ADICIONAR(data, 60);',
    parametros: [
      { nome: 'data', descricao: 'Data para se realizar a operação' },
      { nome: 'dias', descricao: 'Quantidade de dias a se adicionar' },
    ],
  },
  {
    nome: '_ARRUMAR',
    texto: '_ARRUMAR(${1:texto})',
    assinatura: '(texto)',
    descricao: 'Retorna o texto sem espaços em branco do começo, final e espaços seguidos entre as palavras.',
    definicao: `${docsUrl}#_arrumar`,
    exemplo: 'var textoArrumado = _ARRUMAR("Um texto");',
    parametros: [{ nome: 'texto', descricao: 'Texto a ser arrumado' }],
  },
  {
    nome: '_CONCATENAR',
    texto: '_CONCATENAR(${1:texto}, ${2:texto})',
    assinatura: '(texto [, texto])',
    descricao: 'Retorna um novo texto concatenando os textos informados.',
    definicao: `${docsUrl}#_concatenar`,
    exemplo: 'var novoTexto = _CONCATENAR("001.002", ".003", ".004");',
    parametros: [{ nome: 'texto', descricao: 'Texto a ser concatenado' }],
  },
  {
    nome: '_PROCURAR',
    texto: '_PROCURAR(${1:texto}, ${2:termo})',
    assinatura: '(texto, termo)',
    descricao: 'Retorna o índice da primeira ocorrência do termo caso encontrado, do contrário -1.',
    definicao: `${docsUrl}#_procurar`,
    exemplo: 'var indice = _PROCURAR("123456", "3");',
    parametros: [
      { nome: 'texto', descricao: 'Texto' },
      { nome: 'termo', descricao: 'Termo a ser encontrado' },
    ],
  },
  {
    nome: '_SUBSTITUIR',
    texto: '_SUBSTITUIR(${1:texto}, ${2:antigo}, ${3:novo})',
    assinatura: '(texto, antigo, novo)',
    descricao: 'Retorna um novo texto substituindo todas as ocorrências do antigo texto pelo novo.',
    definicao: `${docsUrl}#_substituir`,
    exemplo: 'var novoTexto = _SUBSTITUIR("001.123.003", "123", "002");',
    parametros: [
      { nome: 'texto', descricao: 'Texto inicial' },
      { nome: 'antigo', descricao: 'Texto a ser substituído' },
      { nome: 'novo', descricao: 'Texto a substituir' },
    ],
  },
  {
    nome: '_SUBTEXTO',
    texto: '_SUBTEXTO(${1:texto}, ${2:indiceInicial})',
    assinatura: '(texto, indiceInicial, indiceFinal)',
    descricao: 'Retorna um subconjunto de caracteres do texto informado, entre os índices fornecidos.',
    definicao: `${docsUrl}#_subtexto`,
    exemplo: 'var subtexto = _SUBTEXTO("001.001.123", 4, 7);',
    parametros: [
      { nome: 'texto', descricao: 'Texto a se extrair o subtexto' },
      { nome: 'indiceInicial', descricao: 'Índice inicial  do subtexto' },
      { nome: 'indiceFinal', descricao: '(Opcional) Índice final do subtexto' },
    ],
  },
  {
    nome: '_ARREDONDAR',
    texto: '_ARREDONDAR(${1:entidade}, ${2:casasDecimais})',
    assinatura: '(entidade, casasDecimais)',
    descricao:
      'Arredonda o número informado para a quantidade de casas decimais informada, ou sem casas decimais caso não seja fornecida.',
    definicao: `${docsUrl}#_arredondar`,
    exemplo: 'var numeroArredondado = _ARREDONDAR(10.9);',
    parametros: [
      { nome: 'entidade', descricao: 'Número a ser arredondado' },
      { nome: 'casasDecimais', descricao: 'Número de casas decimais no valor retornado' },
    ],
  },
  {
    nome: '_RAIZ',
    texto: '_RAIZ(${1:numero})',
    assinatura: '(numero)',
    descricao: 'Retorna a raiz quadrada do número informado.',
    definicao: `${docsUrl}#_raiz`,
    exemplo: 'var raizNumero = _RAIZ(9);',
    parametros: [{ nome: 'numero', descricao: 'O número a ser achar a raiz quadrada' }],
  },
  {
    nome: '_ABS',
    texto: '_ABS(${1:numero})',
    assinatura: '(numero)',
    descricao: 'Retorna o valor absoluto do número informado.',
    definicao: `${docsUrl}#_abs`,
    exemplo: 'var numeroAbsoluto = _ABS(9.7);',
    parametros: [{ nome: 'numero', descricao: 'O número a ser achar a valor absoluto' }],
  },
  {
    nome: '_MOD',
    texto: '_MOD(${1:numero}, ${2:divisor})',
    assinatura: '(numero, divisor)',
    descricao: 'Retorna o resto da divisão entre um número e o divisor.',
    definicao: `${docsUrl}#_mod`,
    exemplo: 'var modulo = _MOD(9, 2);',
    parametros: [
      { nome: 'numero', descricao: 'O número a ser dividido' },
      { nome: 'divisor', descricao: 'O número divisor' },
    ],
  },
  {
    nome: '_POTENCIA',
    texto: '_POTENCIA(${1:numero}, ${2:potencia})',
    assinatura: '(numero, potencia)',
    descricao: 'Retorna o resultado de número elevado a uma potência.',
    definicao: `${docsUrl}#_potencia`,
    exemplo: 'var potencia = _POTENCIA(4, 2);',
    parametros: [
      { nome: 'numero', descricao: 'O número a ser elevado' },
      { nome: 'potencia', descricao: 'O expoente para o qual a base é elevada' },
    ],
  },
  {
    nome: '_FATORIAL',
    texto: '_FATORIAL(${1:numero})',
    assinatura: '(numero)',
    descricao: 'Retorna a fatorial do número informado.',
    definicao: `${docsUrl}#_fatorial`,
    exemplo: 'var fato = _FATORIAL(5);',
    parametros: [
      { nome: 'numero', descricao: 'O número a se obter a fatorial. Caso não seja um inteiro, será truncado.' },
    ],
  },
  {
    nome: '_TRUNCAR',
    texto: '_TRUNCAR(${1:numero})',
    assinatura: '(numero)',
    descricao: 'Retorna o número sem suas casas decimais.',
    definicao: `${docsUrl}#_truncar`,
    exemplo: 'var num = _TRUNCAR(5.9);',
    parametros: [{ nome: 'numero', descricao: 'O número a ser avaliado.' }],
  },
  {
    nome: '_COALESCE',
    texto: '_COALESCE(${1:entidade}, ${2:entidade})',
    assinatura: '(entidade [, entidade])',
    descricao: 'Retorna o primeiro valor não nulo informado.',
    definicao: `${docsUrl}#_coalesce`,
    parametros: [{ nome: 'entidade', descricao: 'Valor a ser verificado' }],
  },
  {
    nome: '_LISTA',
    texto: '_LISTA(${1:entidade})',
    assinatura: '(entidade)',
    descricao: 'Indica se a entidade especificada é uma lista.',
    definicao: `${docsUrl}#_lista`,
    parametros: [{ nome: 'entidade', descricao: 'Valor a ser verificado' }],
  },
  {
    nome: '_NUMERO',
    texto: '_NUMERO(${1:entidade})',
    assinatura: '(entidade)',
    descricao: 'Indica se a entidade especificada é numérica.',
    definicao: `${docsUrl}#_numero`,
    parametros: [{ nome: 'entidade', descricao: 'Valor a ser verificado' }],
  },
  {
    nome: '_NULO',
    texto: '_NULO(${1:entidade})',
    assinatura: '(entidade)',
    descricao: 'Indica se a entidade especificada é nula.',
    definicao: `${docsUrl}#_nulo`,
    parametros: [{ nome: 'entidade', descricao: 'Valor a ser verificado' }],
  },
  {
    nome: '_TERNARIO',
    texto: '_TERNARIO(${1:condicao}, ${2:casoPositivo}, ${3:casoNegativo})',
    assinatura: '(condicao, casoPositivo, casoNegativo)',
    descricao:
      'Avalia a condição do primeiro parâmetro e em caso positivo retorna o segundo parâmetro, caso contrário retorna o terceiro.',
    definicao: `${docsUrl}#_ternario`,
    parametros: [
      { nome: 'condicao', descricao: 'Condição a ser avaliada' },
      { nome: 'casoPositivo', descricao: 'Valor caso a comparação seja verdadeira' },
      { nome: 'casoNegativo', descricao: 'Valor caso a comparação seja falsa' },
    ],
  },
  {
    nome: '_SOMA',
    texto: '_SOMA(${1:lista})',
    assinatura: '(lista)',
    descricao: 'Retorna a soma de todos os valores da propriedade especificada da lista informada.',
    definicao: `${docsUrl}#_soma`,
    parametros: [{ nome: 'lista', descricao: 'Lista de valores a serem verificados' }],
  },
  {
    nome: '_SOMASE',
    texto: '_SOMASE(${1:lista}, ${2:condicao})',
    assinatura: '(lista, condicao)',
    descricao:
      'Retorna a soma de todos os valores da propriedade especificada da lista informada, que satisfazem a condição.',
    definicao: `${docsUrl}#_somase`,
    parametros: [
      { nome: 'lista', descricao: 'Lista de valores a serem verificados' },
      { nome: 'condicao', descricao: 'Condição para se realizar a operação' },
    ],
  },
  {
    nome: '_MEDIA',
    texto: '_MEDIA(${1:lista})',
    assinatura: '(lista)',
    descricao: 'Retorna a média entre os valores da propriedade especificada da lista.',
    definicao: `${docsUrl}#_media`,
    parametros: [{ nome: 'lista', descricao: 'Lista de valores a serem verificados' }],
  },
  {
    nome: '_MAXIMO',
    texto: '_MAXIMO(${1:lista})',
    assinatura: '(lista)',
    descricao: 'Retorna o valor máximo entre os valores da propriedade especificada da lista.',
    definicao: `${docsUrl}#_maximo`,
    parametros: [{ nome: 'lista', descricao: 'Lista de valores a serem verificados' }],
  },
  {
    nome: '_MINIMO',
    texto: '_MINIMO(${1:lista})',
    assinatura: '(lista)',
    descricao: 'Retorna o valor mínimo entre os valores da propriedade especificada da lista.',
    definicao: `${docsUrl}#_minimo`,
    parametros: [{ nome: 'lista', descricao: 'Lista de valores a serem verificados' }],
  },
  {
    nome: '_CONT',
    texto: '_CONT(${1:lista})',
    assinatura: '(lista)',
    descricao: 'Retorna a quantidade de itens na lista.',
    definicao: `${docsUrl}#_cont`,
    parametros: [{ nome: 'lista', descricao: 'Lista de valores a serem verificados' }],
  },
  {
    nome: '_CONTSE',
    texto: '_CONTSE(${1:lista}, ${2:condicao})',
    assinatura: '(lista, condicao)',
    definicao: `${docsUrl}#_contse`,
    descricao: 'Retorna a quantidade de itens na lista que satisfazem a condição.',
    parametros: [
      { nome: 'lista', descricao: 'Lista de valores a serem verificados' },
      { nome: 'condicao', descricao: 'Condição para se realizar a operação' },
    ],
  },
  {
    nome: '_FILTRAR',
    texto: '_FILTRAR(${1:lista}, ${2:condicao}, ${3:selecao})',
    assinatura: '(lista, condicao, selecao)',
    definicao: `${docsUrl}#_filtrar`,
    descricao: 'Filtra os itens que correspondem a condição informada, e retorna as propriedades especificadas.',
    exemplo: 'var lista = []; lista[0].Teste = 10; var data = _FILTRAR(lista, x => x.Teste <= 10, x => { x.Teste });',
    parametros: [
      { nome: 'lista', descricao: 'Lista de valores a serem verificados' },
      { nome: 'condicao', descricao: 'Condição para se realizar a operação' },
      { nome: 'selecao', descricao: 'Propriedades de cada item da lista a serem retornadas' },
    ],
  },
  {
    nome: '_PRIMEIRO',
    texto: '_PRIMEIRO(${1:lista}, ${2:condicao}, ${3:selecao})',
    assinatura: '(lista, condicao, selecao)',
    definicao: `${docsUrl}#_primeiro`,
    descricao: 'Busca as propriedades do primeiro item que corresponda a condição informada.',
    exemplo: 'var lista = []; lista[0].Teste = 10; var data = _PRIMEIRO(lista, x => x.Teste <= 10, x => { x.Teste });',
    parametros: [
      { nome: 'lista', descricao: 'Lista de valores a serem verificados' },
      { nome: 'condicao', descricao: 'Condição para se realizar a operação' },
      { nome: 'selecao', descricao: 'Propriedades do item a ser retornado' },
    ],
  },
  {
    nome: '_RETORNOVALOR',
    texto: '_RETORNOVALOR(${1:nome}, ${2:valor})',
    assinatura: '(nome, valor)',
    descricao:
      'Retorna para a aplicação o conteúdo de valor, identificado pelo nome, para ser utilizado em ações posteriores a execução.',
    definicao: `${docsUrl}#_retornovalor`,
    parametros: [
      { nome: 'nome', descricao: 'Identificação do valor' },
      { nome: 'valor', descricao: 'Valor a ser retornado' },
    ],
  },
  {
    nome: '_CARACTERISTICA',
    texto: '_CARACTERISTICA(${1:descricao}, ${2:modulo}, ${3:exercicio})',
    assinatura: '(descricao, modulo [, exercicio])',
    descricao: 'Retorna características que correspondam aos valores informados.',
    definicao: `${docsUrl}#_caracteristica`,
    parametros: [
      { nome: 'descricao', descricao: 'Descrição da característica' },
      { nome: 'modulo', descricao: 'Módulo da característica' },
      { nome: 'exercicio', descricao: '(Opcional) Exercício da característica, caso não informado utiliza o atual' },
    ],
  },
  {
    nome: '_CARACTERISTICA_CODIGO',
    texto: '_CARACTERISTICA_CODIGO(${1:descricao}, ${2:modulo}, ${3:codigo}, ${4:exercicio})',
    assinatura: '(descricao, modulo, codigo [, exercicio])',
    descricao: 'Retorna características que correspondam aos valores informados.',
    definicao: `${docsUrl}#_caracteristica`,
    parametros: [
      { nome: 'descricao', descricao: 'Descrição da característica' },
      { nome: 'modulo', descricao: 'Módulo da característica' },
      { nome: 'codigo', descricao: 'Código da característica' },
      { nome: 'exercicio', descricao: '(Opcional) Exercício da característica, caso não informado utiliza o atual' },
    ],
  },
  {
    nome: '_PARAMETRO',
    texto: '_PARAMETRO(${1:nome}, ${2:descricao}, ${3:exercicio})',
    assinatura: '(nome, descricao [, exercicio])',
    descricao: 'Retorna parâmetros que correspondam aos valores informados.',
    definicao: `${docsUrl}#_parametro`,
    parametros: [
      { nome: 'nome', descricao: 'Nome do parâmetro' },
      { nome: 'descricao', descricao: 'Descrição do parâmetro' },
      { nome: 'exercicio', descricao: '(Opcional) Exercício do parâmetro, caso não informado utiliza o atual' },
    ],
  },
  {
    nome: '_MOEDA',
    texto: '_MOEDA(${1:codigo}, ${2:dataInicial}, ${3:dataFinal})',
    assinatura: '(codigo, dataInicial, dataFinal)',
    descricao: 'Retorna moedas que correspondam aos valores informados.',
    definicao: `${docsUrl}#_moeda`,
    parametros: [
      { nome: 'codigo', descricao: 'Código da moeda' },
      { nome: 'dataInicial', descricao: 'Data inicial da cotação' },
      { nome: 'dataFinal', descricao: 'Data final da cotação' },
    ],
  },
  {
    nome: '_ISENCAO',
    texto: '_ISENCAO(${1:fator}, ${2:baixa}, ${3:local}, ${4:tiposVencimento})',
    assinatura: '(fator, baixa, local, tiposVencimento)',
    descricao: 'Retorna objeto contendo Fator, IdBaixa, Local e Tipos de Vencimento da isenção.',
    definicao: `${docsUrl}#_isencao`,
    parametros: [
      { nome: 'fator', descricao: 'Porcentagem de isenção' },
      { nome: 'baixa', descricao: 'Valor para coluna IdBaixa' },
      { nome: 'local', descricao: 'Valor para coluna Local' },
      { nome: 'tiposVencimento', descricao: 'Tipos de vencimento a se gerar a isenção' },
    ],
  },
  {
    nome: '_PARAMETRO_CODIGO',
    texto: '_PARAMETRO_CODIGO(${1:nome}, ${2:descricao}, ${3:codigo}, ${4:exercicio})',
    assinatura: '(nome, descricao, codigo [, exercicio])',
    descricao: 'Retorna parâmetros que correspondam aos valores informados.',
    definicao: `${docsUrl}#_parametro`,
    parametros: [
      { nome: 'nome', descricao: 'Nome do parâmetro' },
      { nome: 'descricao', descricao: 'Descrição do parâmetro' },
      { nome: 'codigo', descricao: 'Código do valor do parâmetro' },
      { nome: 'exercicio', descricao: '(Opcional) Exercício do parâmetro, caso não informado utiliza o atual' },
    ],
  },
  {
    nome: '_CARACTERISTICATABELA',
    texto: '_CARACTERISTICATABELA(${1:tabela}, ${2:descricao}, ${3:exercicio})',
    assinatura: '(tabela, descricao, [, exercicio])',
    descricao: 'Retorna característica do registro que correspondam aos valores informados.',
    definicao: `${docsUrl}#_caracteristicatabela`,
    parametros: [
      { nome: 'tabela', descricao: 'Tabela a consultar a característica' },
      { nome: 'descricao', descricao: 'Descrição da característica' },
      { nome: 'exercicio', descricao: '(Opcional) Exercício da característica, caso não informado utiliza o atual' },
    ],
  },
  {
    nome: '_ATIVIDADETABELA',
    texto: '_ATIVIDADETABELA(${1:tabela}, ${2:tipo}, ${3:exercicio})',
    assinatura: '(tabela, tipo [, exercicio])',
    descricao: 'Retorna atividades que correspondam aos valores informados.',
    definicao: `${docsUrl}#_atividadetabela`,
    parametros: [
      { nome: 'tabela', descricao: 'Tabela a consultar a atividade.' },
      { nome: 'tipo', descricao: 'Tipo da atividade' },
      {
        nome: 'exercicio',
        descricao: '(Opcional) Exercício da atividade, caso não informado não consulta AtividadeVlrs',
      },
    ],
  },
];
